import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { getStyles } from '../../../utils/utils/commonUtils'
import mainMenuItemStyles from '../styles/mainMenuItemStyles'

import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Collapse, List, ListItem, Stack, useTheme } from '@mui/material'
import { matchPath } from 'react-router'
import MainMenuItem from './MainMenuItem'

type ParentMenuItemProps = {
  name: string
  children: any[]
  toggleMenu: any
}

function ParentMenuItem({ name, children, toggleMenu }: ParentMenuItemProps) {
  const [openItem, setOpenItem] = useState(false)

  const theme = useTheme()
  const classes = getStyles(mainMenuItemStyles)

  const active = children.some((child) =>
    matchPath({ path: child.route }, location.pathname)
  )

  useEffect(() => {
    if (active && !openItem) {
      setOpenItem(true)
    }
  }, [active])

  return (
    <>
      <ListItem
        onClick={() => setOpenItem((prev) => !prev)}
        sx={{
          width: '100%',
          height: '100%',
          padding: '0!important',
          flexDirection: 'column',
        }}
      >
        <Stack
          direction={'row'}
          sx={{ width: '100%', marginBottom: openItem ? '10px' : undefined }}
        >
          <Typography
            component={'div'} //@ts-ignore
            color={theme.palette.gray.light}
            sx={{
              width: '100%',
              height: '100%',
              padding: '12px 34px 12px 64px',
              backgroundColor: active //@ts-ignore
                ? theme.palette.blue.menuSelected
                : 'transparent',
              fontSize: '18px',
              fontWeight: 400,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '40px', //@ts-ignore
              ...classes.menuLink,
            }}
          >
            {name}
            {openItem ? <ExpandLess /> : <ExpandMore />}
          </Typography>
        </Stack>
        <Collapse
          in={openItem}
          timeout={90}
          unmountOnExit
          sx={{ width: '100%' }}
        >
          <List component='div' disablePadding sx={{ width: '100%' }}>
            {children
              .filter((el) => el.visible())
              .map((el: any) => (
                //@ts-ignore
                <ListItem button sx={{ padding: '0!important' }} key={el.name}>
                  <MainMenuItem
                    name={el.name}
                    route={el.route}
                    handleClick={el?.onClick}
                    toggleMenu={toggleMenu}
                    isChild
                  />
                </ListItem>
              ))}
          </List>
        </Collapse>
      </ListItem>
    </>
  )
}

export default observer(ParentMenuItem)
